import { SimpleGrid } from "@mantine/core";
import type { ReactNode } from "react";
import { HelpIcon } from "@dehub/theme";
import { KpiTile, Tone } from "../delivery/atoms";

interface KPI {
  label: string;
  value: ReactNode;
  /** One-line meaning under the value («Одоо шийдвэрлэж буй»). */
  hint?: string;
  /** Leading status dot. */
  tone?: Tone;
  /** Legacy Mantine colour; mapped to a dot tone (the value itself is never coloured). */
  color?: string;
  /** @dehub/help `field` row: inline «?» after the label. */
  helpKey?: string;
}

interface Props {
  kpis: KPI[];
  /** Columns from md up (canvas Ord_ReturnDash: 3). Default = number of tiles. */
  cols?: number;
}

const COLOR_TONE: Record<string, Tone> = {
  green : "green",
  teal  : "green",
  yellow: "amber",
  orange: "red",
  red   : "red",
  gray  : "grey",
};

/** KPI tiles: dot + label, mono value, meta line (canvas KPI row, Ord_Rules O43 card). */
export function ReturnKPICards ({ kpis, cols }: Props){
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: cols ?? kpis.length }} spacing="md">
      {kpis.map((k) => (
        <KpiTile
          key={k.label}
          label={k.helpKey ? <>{k.label}<HelpIcon helpKey={k.helpKey} /></> : k.label}
          value={k.value}
          meta={k.hint}
          tone={k.tone ?? (k.color ? COLOR_TONE[k.color] : undefined)}
        />
      ))}
    </SimpleGrid>
  );
}
